import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

interface TenantSession {
  tenant_id: string;
  account_key: string;
  store_name: string;
  tenant_name: string;
  username: string;
  logged_in_at: Date;
  expires_at: Date;
}

@Injectable({
  providedIn: 'root'
})
export class TenantGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const tenantSessionStr = localStorage.getItem('tenant_session');

    if (!tenantSessionStr) {
      this.redirectToLogin(route);
      return false;
    }

    try {
      const session: TenantSession = JSON.parse(tenantSessionStr);

      // Check if session is expired
      const expiresAt = new Date(session.expires_at);
      if (new Date() > expiresAt) {
        localStorage.removeItem('tenant_session');
        this.redirectToLogin(route);
        return false;
      }

      // Check if account key matches
      const accountKey = route.params.account_key || route.parent?.params.account_key;
      if (accountKey && session.account_key !== accountKey) {
        localStorage.removeItem('tenant_session');
        this.redirectToLogin(route);
        return false;
      }

      return true;
    } catch (error) {
      localStorage.removeItem('tenant_session');
      this.redirectToLogin(route);
      return false;
    }
  }

  private redirectToLogin(route: ActivatedRouteSnapshot): void {
    const accountKey = route.params.account_key || route.parent?.params.account_key || '';
    this.router.navigate([`/tenant/${accountKey}/login`]);
  }
}
